export const IMAGE_BASE_URL="https://api.gangaseed.co.in";